import { useFirebase } from '@/components/providers/site/FirebaseProvider'
import {
  collection,
  orderBy as firestoreOrder,
  getDocs,
  query
} from 'firebase/firestore'
import { EntityOptions, useReadEntity } from '../useEntity'
import { mapChatResult } from './useChatMessages'

export const useChatMessageRevisions = (
  options: EntityOptions & {
    messageId: string
  }
) => {
  const { firestore } = useFirebase()

  const collectionKey = `Social_Chat/${options.idOrKey}/messages/${options.messageId}/revisions`
  const db = firestore

  const revisions = useReadEntity({
    key: 'useChatMessageRevisions' + options.messageId,
    ...options,
    read: async () => {
      const c = collection(db, collectionKey)
      const q = query(c, firestoreOrder('dateCreated', 'desc'))
      return getDocs(q).then(res => {
        return {
          content: res.docs.map(it => mapChatResult(it))
        }
      })
    }
  })

  return {
    ...revisions,
    revisions: revisions.read.data
  }
}
